import { twMerge } from 'tailwind-merge';
import { HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';

type LabelProps = {
    disabled: boolean,
    required: boolean,
    invalid: boolean,
} & HTMLProps<HTMLLabelElement>

export const Label = ({ required, disabled, invalid, className, children, ...rest }: LabelProps) => {
    const { t } = useTranslation(['misc']);

    return (
        <label
            {...rest}
            className={twMerge(
                'mb-1 block ps-1 text-sm font-medium text-on-background',
                disabled && 'text-opacity-60',
                invalid && 'text-error',
                className
            )}
        >
            {children}
            {!required && (
                <>
                    &nbsp;
                    <span className={'text-xs text-outline'}>
                        {t('misc:optional')}
                    </span>
                </>
            )}
        </label>
    );
};
